'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ASCENDING = 'ascending';
var DESCENDING = 'descending';

var BasicReportHeader = function BasicReportHeader(props) {
  var onOrderChanged = props.onOrderChanged,
      order = props.order,
      withDeleteButton = props.withDeleteButton;


  var isPlatformSort = order.field === 'platform';
  var isInfluencerSort = order.field === 'influencer';
  var isViewsSort = order.field === 'views';
  var isThumbsUpSort = order.field === 'thumbsUp';
  var isCommentsSort = order.field === 'comments';
  var isShareSort = order.field === 'shares';

  var isASC = order.value === ASCENDING;
  var sortedValue = isASC ? ASCENDING : DESCENDING;
  var clickValue = isASC ? DESCENDING : ASCENDING;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 1,
        sorted: isPlatformSort && sortedValue,
        onClick: function onClick() {
          return onOrderChanged('platform', clickValue);
        }
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'channel'
        ),
        content: 'sort by platform'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      { width: 1 },
      _react2.default.createElement(
        'span',
        null,
        'image'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 4,
        sorted: isInfluencerSort && sortedValue,
        onClick: function onClick() {
          return onOrderChanged('influencer', clickValue);
        }
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'influencer - asset'
        ),
        content: 'sort by influencer'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      { width: 1 },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', color: 'grey' }),
        content: 'view detailed post performance data (or the live post)'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      { width: 1 },
      _react2.default.createElement(
        'span',
        null,
        'source'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 1,
        sorted: isViewsSort && sortedValue,
        onClick: function onClick() {
          return onOrderChanged('views', clickValue);
        }
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'views'
        ),
        content: 'sort by views'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      { width: 1 },
      _react2.default.createElement(
        'span',
        null,
        'reach'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      { width: 1 },
      _react2.default.createElement(
        'span',
        null,
        'impressions'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 1,
        sorted: isThumbsUpSort && sortedValue,
        onClick: function onClick() {
          return onOrderChanged('thumbsUp', clickValue);
        }
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'likes'
        ),
        content: 'sort by number of likes'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 1,
        sorted: isCommentsSort && sortedValue,
        onClick: function onClick() {
          return onOrderChanged('comments', clickValue);
        }
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'comments'
        ),
        content: 'sort by number of comments'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        sorted: isShareSort && sortedValue,
        onClick: function onClick() {
          return onOrderChanged('shares', clickValue);
        },
        width: 1
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'shares'
        ),
        content: 'sort by number of retweets or shares'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      { width: 1 },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'grey' }),
          '#ad?'
        ),
        content: 'This confirms that the post includes #ad, #spon, #partner'
      })
    ),
    withDeleteButton && _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      { width: 1 },
      _react2.default.createElement(
        'span',
        null,
        'remove'
      )
    )
  );
};

BasicReportHeader.propTypes = {
  onOrderChanged: _propTypes2.default.func.isRequired,
  order: _propTypes2.default.object.isRequired,
  withDeleteButton: _propTypes2.default.bool.isRequired
};

BasicReportHeader.defaultProps = {
  withDeleteButton: false
};

exports.default = BasicReportHeader;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-header/index.js
 ** module id = 2603
 ** module chunks = 0
 **/